import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const InfoOutlinedIcon = memo(({ fontSize, color = colors.grey170, display, className }: SvgIconProps) => (
  <SvgIcon width="15" height="15" viewBox="0 0 15 15" fill="none" className={className} style={{ fontSize, display }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.93873 5.23039C7.84328 5.32584 7.69094 5.41666 7.5 5.41666C7.30906 5.41666 7.15672 5.32584 7.06127 5.23039C6.96583 5.13494 6.875 4.9826 6.875 4.79166C6.875 4.60073 6.96583 4.44838 7.06127 4.35294C7.15672 4.25749 7.30906 4.16666 7.5 4.16666C7.69094 4.16666 7.84328 4.25749 7.93873 4.35294C8.03417 4.44838 8.125 4.60073 8.125 4.79166C8.125 4.9826 8.03417 5.13494 7.93873 5.23039Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 11.2716C7.15482 11.2716 6.875 11.0159 6.875 10.7005L6.875 6.84263C6.875 6.52724 7.15482 6.27156 7.5 6.27156C7.84518 6.27156 8.125 6.52724 8.125 6.84263L8.125 10.7005C8.125 11.0159 7.84518 11.2716 7.5 11.2716Z"
      fill={color}
    />
  </SvgIcon>
));
